$(function($){
  function goToReview() {
    const $ratingWidget = $('.rating_widget');
    const $reviews = $('#ssw-widget-recommends-html');

    if (!$ratingWidget.length || !$reviews.length) return false;

    $ratingWidget.click(function() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $reviews.offset().top
      }, 1000);
    });
  }

  function toggleWishlist() {
    $('.header-wishlist-toggle').on('click', function() {
      const $wishlistBtn = $('#ssw-fave-side-button');

      if (!$wishlistBtn.length) return false;

      $wishlistBtn.click();
    })
  }

  function ajaxGiftWrapping() {
    $('#CartDrawer').on('change', '#ajax-gift-wrapping', function() {
      if ($(this).is(':checked')) {
        $('.ajax-on-check').show();
      }
      else {
        $('.ajax-on-check').hide();
      }
    });

    $('#CartDrawer').on('click', '.ajax-add-wrapping', function(){
      Shopify.AjaxCart.GiftWrap.set();
      $('#ajax-gift-wrapping').attr('checked', false);
    });
  }

  function serchInfoToggle() {
    const $searchInput = $('.header_nav-search #search');
    const $searchInfo = $('.header_nav-search .search_menu_info');

    if (!$searchInput.length || !$searchInfo.length) return false;

    $searchInput.on('input focus', function () {
      if ($(this).val()) {
        $searchInfo.hide();
      } else {
        $searchInfo.show();
      }
    })

    $(document).click(function(e) {
      if(!$(e.target).closest('.search_menu').length) {
        $searchInfo.hide();
      };
    })
  }

  function ajaxCartFunctions() {
    $(document).on('click', '.ajaxcart__cart-note-title', function() {
      if($('body').hasClass('cart_accordion') || $('html').hasClass('cart_accordion')) {
        $(this).toggleClass('active').siblings('.cart_note').slideToggle();
      }
    })
  }

  function relatedTest() {
    if (!$('.template-product').length) return;

    if ($(window).width() > 768) {
      $('.discover-more-169').append($('.product__related-inner'));
      $('.product__related').insertBefore($('#ssw-widget-recommends-html'));
    } else {
      $('.product__related').insertAfter($('.detail'));
    }
  }

  function sliders() {
    $('.product__slider').slick({
      prevArrow: '<div class="product__slider-arrow product__slider-arrow--prev"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="284.935px" height="284.936px" viewBox="0 0 284.935 284.936" style="enable-background:new 0 0 284.935 284.936;" xml:space="preserve"> <g> <path d="M110.488,142.468L222.694,30.264c1.902-1.903,2.854-4.093,2.854-6.567c0-2.474-0.951-4.664-2.854-6.563L208.417,2.857 C206.513,0.955,204.324,0,201.856,0c-2.475,0-4.664,0.955-6.567,2.857L62.24,135.9c-1.903,1.903-2.852,4.093-2.852,6.567 c0,2.475,0.949,4.664,2.852,6.567l133.042,133.043c1.906,1.906,4.097,2.857,6.571,2.857c2.471,0,4.66-0.951,6.563-2.857 l14.277-14.267c1.902-1.903,2.851-4.094,2.851-6.57c0-2.472-0.948-4.661-2.851-6.564L110.488,142.468z"/> </g> </svg> </div>',
      nextArrow: '<div class="product__slider-arrow product__slider-arrow--next"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="284.935px" height="284.936px" viewBox="0 0 284.935 284.936" style="enable-background:new 0 0 284.935 284.936;" xml:space="preserve"> <g> <path d="M222.701,135.9L89.652,2.857C87.748,0.955,85.557,0,83.084,0c-2.474,0-4.664,0.955-6.567,2.857L62.244,17.133 c-1.906,1.903-2.855,4.089-2.855,6.567c0,2.478,0.949,4.664,2.855,6.567l112.204,112.204L62.244,254.677 c-1.906,1.903-2.855,4.093-2.855,6.564c0,2.477,0.949,4.667,2.855,6.57l14.274,14.271c1.903,1.905,4.093,2.854,6.567,2.854 c2.473,0,4.663-0.951,6.567-2.854l133.042-133.044c1.902-1.902,2.854-4.093,2.854-6.567S224.603,137.807,222.701,135.9z"/> </g> </svg> </div>',
      adaptiveHeight: true,
    });
    $('.product__thumbnails').slick({
      slidesToShow: 6,
    });

    $('.product__thumbnail').on('click', function() {
      let index = $(this).attr('data-index');
      $('.product__slider').slick('slickGoTo', index);
    })

    var mySwiper = new Swiper ('.home_collections_slider, .product__slider-container', {
      // Optional parameters
      direction: 'horizontal',
      spaceBetween: 12,
      slidesPerView: 4,

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    new Swiper ('.top_bar-list.swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: $('.top_bar-list.swiper-container').data('swiper-autoplay'),
        },
    })
  }

  function stickyAdd() {
    if ($(window).width() < 768 && $('.template-product').length) {
      let btn = $('.add_to_cart');
      let btnPos = btn.offset().top;
      $(window).on('scroll', function () {
        if ($(window).scrollTop() > btnPos) {
          btn.addClass('fixed');
          $('.ssw-reward-tab').css('bottom', '65px');
        } else {
          btn.removeClass('fixed');
          $('.ssw-reward-tab').css('bottom', '15px');
        }
      })
    }
  }

  // function filters() {
  //   if (!$('.template-collection').length) return;

  //   const target = document.querySelector('.products-list');
  //   const config = {
  //     subtree: true,
  //     childList: true,
  //   };

  //   const callback = function(mutationsList, observer) {
  //     for (let mutation of mutationsList) {
  //       if($('.gf-refine-toggle-mobile').length) {
  //         observer.disconnect();
  //         console.log(mutation);
  //         //$('.collection__newest-sort').insertAfter($('.gf-refine-toggle-mobile'))
  //       }
  //     }
  //   };

  //   const observer = new MutationObserver(callback);
  //   observer.observe(target, config);
  // }

  $('.rewards-points__open-popup').magnificPopup({
    type:'inline',
    midClick: true
  });

  function exitPopup() {
    var prevEvent, currentEvent;
    document.documentElement.onmousemove=function(event){
      currentEvent=event;
    }

    var checkScrollSpeed = (function(settings){
      settings = settings || {};

      var lastPos, newPos, timer, delta,
          delay = settings.delay || 50; // in "ms" (higher means lower fidelity )

      function clear() {
        lastPos = null;
        delta = 0;
      }

      clear();

      return function(){
        newPos = window.scrollY;
        if ( lastPos != null ){ // && newPos < maxScroll
          delta = newPos -  lastPos;
        }
        lastPos = newPos;
        clearTimeout(timer);
        timer = setTimeout(clear, delay);
        return delta;
      };
    })();

    // listen to "scroll" event
    window.onscroll = function(){
      var documentHeight = $(document).height();
      var windowHeight = $(window).height();
      var scrollTop = $(window).scrollTop();
      var halfPos = (scrollTop + windowHeight / 2) < (documentHeight / 2)
      if(checkScrollSpeed() < -150 && window.cartCount && !localStorage.getItem('exitPopupClosed') && halfPos) {
        openExitPopup();
      }
    };

    var maxSpeed=0,prevSpeed=0,maxPositiveAcc=0,maxNegativeAcc=0;
    setInterval(function(){
      if(prevEvent && currentEvent){
        var positionY = currentEvent.clientY;
        var movementX=Math.abs(currentEvent.screenX-prevEvent.screenX);
        var movementY=currentEvent.screenY-prevEvent.screenY
        var movement=Math.sqrt(movementX*movementX+movementY*movementY);

        var speed=10*movement;

        if(window.cartCount && speed > 400 && movementY < -50 && positionY < 30 && !localStorage.getItem('exitPopupClosed')) {
          openExitPopup();
        }

      }

      prevEvent=currentEvent;
      prevSpeed=speed;
    },100);

    function openExitPopup() {
      $('body').addClass('muted');
      $('#exitPopup').show();
    }
    $('.exit-popup__checkout').click(function(e) {
      localStorage.setItem('exitPopupClosed', true);
    })
    $('.exit-popup__exit').on('click', function() {
      localStorage.setItem('exitPopupClosed', true);
      $('.exit-popup__wrap').hide();
      $('body').removeClass('muted');
    })
  }

  function photoTest() {
    if (!$('.template-product').length) return;

    const target = document.querySelector('body');
    const config = {
      attributes: true
    };

    const callback = function(mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes') {
          if(!$('body').hasClass('photo_test')) return;
          $('.product__thumbnails').slick('destroy')
          $('.product__thumbnails').slick({
            slidesToShow: 6,
            rows: 2,
          })

          observer.disconnect();
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(target, config);
  }

  function productSwatches() {
    $('.product__swatches-item').on('click', function() {
      $('.product__swatches-item.active').removeClass('active');
      $(this).addClass('active');
      $('.product-select').val($(this).attr('data-variant'));
      $('#product-price').html($(this).attr('data-price'));
      $('.validation-advice').remove();
    })
  }

  function imageZoom() {
    var viewer = ImageViewer();
    $('#product-detail-main-image, img.product__slider-item').click(function () {
      // $('.iv-large-image').wrap('<div>');
      var imgSrc = this.src,
          highResolutionImage = $(this).attr('data-high-res-img');

      viewer.show(imgSrc, highResolutionImage);
      $('.iv-large-image').wrap('<div class="iv-large-image-wrap">');
    });
    var zoomSize = $('.pannable-image[data-high-res-img]').length;
    var zoomArr = [];
    $('.pannable-image[data-high-res-img]').each(function(item, index) {
      zoomArr.push($(this).attr('data-high-res-img').replace('https:', ''));
    })
    $('.iv-container').append('<div class="iv__arrow-background--prev"></div><div class="iv__arrow iv__arrow--prev"></div>')
    $('.iv-container').append('<div class="iv__arrow-background--next"></div><div class="iv__arrow iv__arrow--next"></div>')
    $(document).on('click', '.iv__arrow--prev', function() {
      var currentIndex = zoomArr.indexOf($('.iv-large-image').attr('src').replace('https:', ''));
      if(currentIndex == 0) {
        viewer.load(zoomArr[zoomSize - 1], zoomArr[zoomSize - 1]);
      }
      else {
        viewer.load(zoomArr[currentIndex - 1], zoomArr[currentIndex - 1]);
      }
      $('.iv-large-image').wrap('<div class="iv-large-image-wrap">');
    })
    $(document).on('click', '.iv__arrow--next', function() {
      var currentIndex = zoomArr.indexOf($('.iv-large-image').attr('src').replace('https:', ''));
      if(currentIndex == zoomSize - 1) {
        viewer.load(zoomArr[0], zoomArr[0]);
      }
      else {
        viewer.load(zoomArr[currentIndex + 1], zoomArr[currentIndex + 1]);
      }
      $('.iv-large-image').wrap('<div class="iv-large-image-wrap">');
    })
    $('.product__slider-faq').click(function() {
      $(this).siblings('img').click();
    })
  }

  function sizeGuide() {
    $('.size-guide__link').on('click', function() {
      $('#sizeGuide').show();
      $('body').addClass('muted');
    })
    $('.size-guide__close').on('click', function() {
      $('#sizeGuide').hide();
      $('body').removeClass('muted');
    })
  }

  function bestSelling() {
    if($('.template-collection').length) {
      const urlParams = new URLSearchParams(window.location.search);
      const hasQParamOnly = urlParams.has('q');
     
      if (hasQParamOnly) {
      const vendor = urlParams.get('q');
      var colHandle = vendor.split(' ').join('-');
      console.log(colHandle);     
      }else{
      var colHandle = location.pathname.split('/').pop();
      }
   
      $.ajax({
        method: 'get',
        url: '/collections/' + colHandle + '?view=best&sort_by=best-selling',
        success: function(data) {
          $('.collection__best-list').append(data);
          $('.collection__best-list').slick({
            slidesToShow: 4,
            prevArrow: '<div class="collection__best-arrow collection__best-arrow--prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
            nextArrow: '<div class="collection__best-arrow collection__best-arrow--next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3
                }
              }
            ]
          });
        }
      })

    }
  }

  function fixedHeader() {
    if($(window).width() < 768) {
      $(window).on('scroll', function() {
        if($(window).scrollTop() > 50) {
          $('body').addClass('header-fixed');
        }
        else {
          $('body').removeClass('header-fixed');
        }
      })
    } else {
      if ($('body').hasClass('header-fixed')) {
        $('body').removeClass('header-fixed');
      }
    }
  }

  function mobileMenu() {
    $('.mobile-menu__parent').click(function() {
      if($(this).closest('.mobile-menu__wrap').hasClass('opened')) {
        $(this).closest('.mobile-menu__wrap').removeClass('opened').find('.mobile-menu__sublist').slideUp();;
      }
      else {
        $('.mobile-menu__wrap.opened').removeClass('opened').find('.mobile-menu__sublist').slideUp();
        $(this).closest('.mobile-menu__wrap').addClass('opened').find('.mobile-menu__sublist').slideDown();
      }
    })
    $('.mobile-menu__close').click(function() {
      $('body').removeClass('menu-opened');
    })
  }

  function entrancePopup() {
    if($('.template-product').length) {
      localStorage.setItem('entranceImage', $('.ProductSection').attr('data-productImage'))
      localStorage.setItem('entranceUrl', $('.ProductSection').attr('data-productUrl'))
    }

    if($('.template-index').length) {
      const target = document.querySelector('body');
      const config = {
        attributes: true,
      };

      const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'attributes') {
            if(localStorage.getItem('entranceUrl') && document.referrer.indexOf('gnr8.jp') == -1) {
              $('.entrance__wrap').addClass('active');
              $('body').addClass('muted');
              $('.entrance__image').attr('src', localStorage.getItem('entranceImage'));
              $('.entrance__button').attr('href', localStorage.getItem('entranceUrl'));
            }
            $('.entrance__close').click(function() {
              $('.entrance__wrap').removeClass('active');
              $('body').removeClass('muted');
            })

            observer.disconnect()
          }
        }
      };


      const observer = new MutationObserver(callback);
      observer.observe(target, config);
    }
  }

  function collection() {

  }

  function filterTags() {
    const target = document.querySelector('body');
    const config = {
      subtree: true,
      attributes: true
    };

    const callback = function(mutationsList, observer) {
      for (let mutation of mutationsList) {
        if ($('.gf-option-block--カテゴリーで絞る').length) {
          $('.collection__tag-filters').append($('.gf-option-block--カテゴリーで絞る .gf-option-box'));

          $('.collection__tag-filters .gf-option-box').flickity({
            pageDots: false,
            prevNextButtons: false,
            freeScroll: true,
            contain: true,
          })

          $('.collection__tag-filters').find('li').click(function() {
            console.log('hh')
            $(this).find('a').toggleClass('checked');
          })

          observer.disconnect()
        }
      }
    };


    const observer = new MutationObserver(callback);
    observer.observe(target, config);
  }

  function productAnchors() {
    if($('.template-product').length && $(window).width() < 768) {
      var anchors = '.p-anchors__item';
      var anchorsBlocks = window.anchorsBlocks;
      $(anchors).click(function(e) {
        e.preventDefault();
        var block = $(this).attr('href')
        $("html, body").animate({ scrollTop: $(block).offset().top - 110 }, 444);
      })
      $(window).scroll(function () {
        if($(window).scrollTop() >= 500) {
          if($('body').hasClass('test_159')) {
            var positionTop = $('.header-fixed-top').outerHeight() + 'px';
            console.log(positionTop);
            $('.p-anchors').css('top', positionTop);
          }
          $('.p-anchors').addClass('visible');
        }
        else {
          $('.p-anchors').removeClass('visible');
        }
        anchorsBlocks.forEach(elem => isInViewport(elem));
      });
    }

  }
  
  function isInViewport (elem) {
    let elementTop = $(elem).offset().top + $(window).height() - 120;
    let elementBottom = elementTop + $(elem).outerHeight() - $(window).height();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    if(elementBottom > viewportTop && elementTop < viewportBottom) {
      $(`.p-anchors__item[data-anchor=${elem.replace('#', '')}]`).addClass('active');
    }
    else {
      $(`.p-anchors__item[data-anchor=${elem.replace('#', '')}]`).removeClass('active');
    }
  };

  function initCategoryListToggle() {
    const $categoryList = $(".category-list");
    const $categoryListToggleBtn = $(".category-list__show-more");

    $categoryListToggleBtn.on('click', (e) => {
      e.preventDefault();

      const $target = $(e.currentTarget);
      $categoryList.toggleClass('opened');
      $categoryList.hasClass('opened') ? $target.text('See less') : $target.text('See more');
    })
  }

  goToReview();
  toggleWishlist();
  ajaxGiftWrapping();
  serchInfoToggle();
  ajaxCartFunctions();
  relatedTest();
  sliders();
  stickyAdd();
  exitPopup();
  photoTest();
  productSwatches();
  // filters();
  imageZoom();
  sizeGuide();
  bestSelling();
  fixedHeader();
  mobileMenu();
  entrancePopup();
  collection();
  filterTags();
  productAnchors();
  initCategoryListToggle();
  test_160();
  test_169();
  test_182();
  test_181();
  
  $(window).resize(function(){
    fixedHeader();
    test_182();
  });
})

function test_160() {
  $('.sub-category-title').on('click', function() {
    if($(window).width() < 768) {
      $(this).toggleClass('active');
      $('.sub-category').slideToggle();
    }
  });
}

function test_169() {
  $('.detail_tab_heading').on('click', function() {
    if($(window).width() < 992) {
      let tabIndex = $(this).data('tab');
      $(this).addClass('active').siblings().removeClass('active');
      $(this).closest('.prod_info-test_169').find('.detail_content').removeClass('active');
      $(this).closest('.prod_info-test_169').find('.detail_content[data-tab="'+tabIndex+'"]').addClass('active');
    }
  });
}

function test_182() {
  $('#search_mini_form input#search').on('click', function() {
    if($(window).width() < 768) {
      if (!$(this).closest('.m_search').hasClass('fixed')) {
        $(this).closest('.m_search').addClass('fixed');
        $('body, html').addClass('no-scroll');
        $('#shopify-section-header').addClass('hide-hamburger-menu');
        $('.m_search-bg').show();
      }
    }
  });
  $('#search_mini_form .close-search, #search_mini_form .m_search-bg').on('click', function() {
    $(this).closest('.m_search').removeClass('fixed');
    $('body, html').removeClass('no-scroll');
    $('.search_menu_info, .m_search-bg').hide();
    $('#shopify-section-header').removeClass('hide-hamburger-menu');

  });
  if ($(window).width() > 767 && $('div.search_menu ul li.m_search').hasClass('fixed')) {
    $('div.search_menu ul li.m_search').removeClass('fixed');
    $('body, html').removeClass('no-scroll');
    $('.search_menu_info, .m_search-bg').hide();
    $('#shopify-section-header').removeClass('hide-hamburger-menu');
  }
}

function test_181() {
  $('.cart_note_collapse').on('click', function() {
    if($(window).width() < 768 && $('body').hasClass('test_181')) {
      $(this).toggleClass('active');
      $(this).parent().find('.text-area-cart_note').slideToggle();
    }
  });
}